import tinymce from 'tinymce'
import response from '../../../utils/response'
import { imgAddHost } from '../../../utils/index.js'

/**
 * 图片上传
 * @param {*} blobInfo
 * @param {*} success
 * @param {*} failure
 * @param {*} uploadUrl
 * @returns
 */
export const imageUploadHandler = (blobInfo, success, failure, uploadUrl) => new Promise(async () => {
  if (!uploadUrl) return
  if (blobInfo.blob().size > 5 * 1024 * 1024) {
    failure('上传图片不能超过5M')
    return
  }
  const formData = new FormData()
  formData.append('file', blobInfo.blob(), blobInfo.filename())
  const res = await response(window.vueInstantiation.$http('post', uploadUrl, formData), {loadingOptions: true})
  if (res.isOk) {
    let imgUrl = imgAddHost(res.content.url)
    success(imgUrl)
  }
})

/**
 * 创建上传文件按钮
 * @param {Function} cb
 */
export const pickerCallbackHandler = (cb) => {
  const input = document.createElement('input')
  input.setAttribute('type', 'file')
  input.setAttribute('accept', 'image/jpeg,image/jpg,image/png,image/gif,image/bmp,image/svg')

  input.addEventListener('change', (e) => {
    const file = e.target.files[0]
    const reader = new FileReader()
    if (file.size > 5 * 1024 * 1024) {
      showDialog('上传图片不能超过5M')
      return
    }
    reader.addEventListener('load', () => {
      const id = 'blobid' + (new Date()).getTime()
      const blobCache =  tinymce.activeEditor.editorUpload.blobCache
      const base64 = reader.result.split(',')[1]
      const blobInfo = blobCache.create(id, file, base64)
      blobCache.add(blobInfo)
      cb(blobInfo.blobUri(), { title: file.name })
    })
    reader.readAsDataURL(file)
  })
  input.click()
}

/**
 * tinymce弹框
 * @param {String} text
 */
function showDialog (text) {
  const dialogConfig = {
    title: '提示',
    body: {
      type: 'panel',
      items: [
        {
          type: 'htmlpanel',
          html: text
        }
      ]
    },
    buttons: [
      {
        type: 'cancel',
        text: 'OK',
        primary: true
      }
    ]
  }
  tinymce.activeEditor.windowManager.open(dialogConfig)
}